import React, { useState } from "react"
import PropTypes from "prop-types"
import CertHistoryRowHeader from "./CertHistoryRowHeader"
import { Col, Row } from "reactstrap"
import CertHistoryRowContent from "./CertHistoryRowContent"
import classnames from "classnames"
import {
  getChapterSelectionState,
  collectLeafParts,
} from "pages/CertificationsHistory/utils/certificationsHistoryInvoiceDraft"

const CertHistoryRow = ({
  title,
  data,
  isSubItem = false,
  lastCert = false,
  isInvoicing = false,
  selectedParts,
  invoicingDrafts,
  onToggleSelectedPart,
  onToggleSelectedChapter,
  onUpdateInvoicingDraft,
  onPersistInvoicingAmount,
  onOpenMeasuresDialog,
  numberPrefix = "",
}) => {
  const [showRow, setShowRow] = useState(false)
  const invoicingProps = {
    invoicingDrafts,
    onUpdateInvoicingDraft,
    onPersistInvoicingAmount,
  }
  const chapterSelectionState = getChapterSelectionState(data, selectedParts)
  const totalInvoicedAmount = isInvoicing
    ? collectLeafParts(data).reduce(
        (sum, part) => sum + (part?.invoicedAmount ?? 0),
        0,
      )
    : 0

  return (
    <Row
      xs={12}
      style={{ margin: isSubItem ? "10px 0px" : "0px 0px 10px 0px" }}
      aria-label="general-row"
    >
      <Col
        xs={12}
        className=""
        style={{ padding: 0 }}
        onClick={() => {
          setShowRow(!showRow)
        }}
      >
        <CertHistoryRowHeader
          title={title}
          showDownloadIcon={!isSubItem}
          showSelectionCheckbox={
            isInvoicing && chapterSelectionState?.hasLeafParts
          }
          selectionChecked={chapterSelectionState?.checked ?? false}
          selectionIndeterminate={chapterSelectionState?.indeterminate ?? false}
          selectionLabel={
            isSubItem ? "Seleccionar capítulo" : "Seleccionar certificación"
          }
          onToggleSelection={() => onToggleSelectedChapter(data)}
          totalCertPrice={data.totalCertPrice}
          totalInvoicedAmount={isInvoicing ? totalInvoicedAmount : undefined}
          date={data.revisionDate}
          certId={data.id}
          lastCert={lastCert}
        />
      </Col>

      <Col
        xs={12}
        className={classnames("mt-1 rounded-2", {
          hide: !showRow,
          backgroundWhite: data.chapters.length === 0,
          backgroundLightBlue: data.chapters.length > 0,
        })}
        aria-label="general-Content"
      >
        {data.chapters && data.chapters.length > 0 ? (
          data.chapters.map(c => {
            const childNumber = `${numberPrefix}${(c.position || 0) + 1}`
            return (
              <CertHistoryRow
                key={c.chapterId}
                data={c}
                title={`${childNumber} ${c.name}`}
                isSubItem
                isInvoicing={isInvoicing}
                selectedParts={selectedParts}
                {...invoicingProps}
                onToggleSelectedPart={onToggleSelectedPart}
                onToggleSelectedChapter={onToggleSelectedChapter}
                onOpenMeasuresDialog={onOpenMeasuresDialog}
                numberPrefix={`${childNumber}.`}
              />
            )
          })
        ) : (
          <CertHistoryRowContent
            data={data.parts}
            isInvoicing={isInvoicing}
            selectedParts={selectedParts}
            {...invoicingProps}
            onToggleSelectedPart={onToggleSelectedPart}
            onOpenMeasuresDialog={onOpenMeasuresDialog}
            numberPrefix={numberPrefix}
          />
        )}
      </Col>
    </Row>
  )
}

CertHistoryRow.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  isSubItem: PropTypes.bool,
  lastCert: PropTypes.bool,
  isInvoicing: PropTypes.bool,
  selectedParts: PropTypes.object.isRequired,
  invoicingDrafts: PropTypes.object.isRequired,
  onToggleSelectedPart: PropTypes.func.isRequired,
  onToggleSelectedChapter: PropTypes.func.isRequired,
  onUpdateInvoicingDraft: PropTypes.func.isRequired,
  onPersistInvoicingAmount: PropTypes.func.isRequired,
  onOpenMeasuresDialog: PropTypes.func,
  numberPrefix: PropTypes.string,
}

export default CertHistoryRow
